module.exports = __webpack_public_path__ + "img/tyreLink.5665402a.svg";